/**
 * On-position Restrain indicator: "RESTRAIN 4:12" (h:mm:ss over an hour) or
 * "RESTRAIN until flat". Renders nothing when no restrain applies to this
 * position (matched by brokerId + accountId + contract), when it has expired,
 * or when the position is flat. A pure view of restrainStore.
 */
import React from 'react';
import { formatRestrainRemaining, restrainLockMessage } from '../../store/restrainStore';
import { useRestrainFor } from './useRestrain';
import './Restrain.css';

export interface RestrainBadgeProps {
  position: {
    brokerId?: string | null;
    accountId?: number | string | null;
    symbol?: string | null;
    contractId?: number | string | null;
    netPos: number;
  } | null | undefined;
  /** Chart symbol, used when the position carries none. */
  fallbackSymbol?: string;
  className?: string;
}

export const restrainBadgeLabel = (endsAt: number | null, now: number): string =>
  endsAt == null ? 'RESTRAIN until flat' : `RESTRAIN ${formatRestrainRemaining(endsAt - now)}`;

const RestrainBadge: React.FC<RestrainBadgeProps> = ({ position, fallbackSymbol, className }) => {
  const { entry, now } = useRestrainFor(position ? { ...position, fallbackSymbol } : null);
  if (!entry) return null;
  return (
    <span
      className={`restrain-badge${className ? ` ${className}` : ''}`}
      title={restrainLockMessage(entry)}
      data-testid="restrain-badge"
    >
      {restrainBadgeLabel(entry.endsAt, now)}
    </span>
  );
};

export default RestrainBadge;
